module.exports = __webpack_public_path__ + "media/images/game_icon/vi/AB1506-e2ef67d5beedc1f78a16e20f76fbf0ea.png";